(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('faq', {
            parent: 'app',
            url: '/faq',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/faq/faq.html',
                    controller: 'FaqController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }],
                faqEntities: ['$stateParams', 'NasracWebContent', function($stateParams, NasracWebContent) {
                    return NasracWebContent.getPage({page : 'faq'}).$promise;
                }]
            }
        });
    }
})();
